import React from 'react'
import {BaseIcon, type IconProps} from './icon-base'

export const HomeIcon: React.FC<IconProps> = (props) => (
    <BaseIcon {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10.75 12 3l9 7.75" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.5 9.75V20h13V9.75" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.5 20v-6h5v6" />
    </BaseIcon>
)

export const ReservationsIcon: React.FC<IconProps> = (props) => (
    <BaseIcon {...props}>
        <rect width="8" height="4" x="8" y="2" rx="1" ry="1" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 11h4" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 16h4" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 11h.01" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16h.01" />
    </BaseIcon>
)

export const SchedulesIcon: React.FC<IconProps> = (props) => (
    <BaseIcon {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 2v4" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 2v4" />
        <rect width="18" height="18" x="3" y="4" rx="2" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 14h.01" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14h.01" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 14h.01" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 18h.01" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 18h.01" />
    </BaseIcon>
)

export const MembersIcon: React.FC<IconProps> = (props) => (
    <BaseIcon {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M22 21v-2a4 4 0 0 0-3-3.87" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 3.13a4 4 0 0 1 0 7.75" />
    </BaseIcon>
)

export const FacilityIcon: React.FC<IconProps> = (props) => (
    <BaseIcon {...props}>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
    </BaseIcon>
)

export const PaymentIcon: React.FC<IconProps> = (props) => (
    <BaseIcon {...props}>
        <rect width="20" height="14" x="2" y="5" rx="2" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2 10h20" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 15h2" />
    </BaseIcon>
)
